/*  */
import * as React from 'react';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities';
import TranslationActions from 'actions/TranslationActions';
import errorLogger from 'utils/errorLogger';

/* Component to translate text to any language
 *
 * getInitialState() {
 *   return {
 *     lang: 'en'
 *   };
 * },
 *
 * componentDidMount() {
 *   setTimeout(() => this.setState({lang: 'es'}, 2000)); // translate to spanish
 *   setTimeout(() => this.setState({lang: 'en'}, 4000)); // translate back to english
 * },
 *
 * onLanguageChanged(lang) {
 *   console.log('translated to ' + lang)
 * }
 *
 * render() {
 *   return (
 *     <TranslatableText
 *       text="hello"
 *       lang={this.state.lang}
 *       onLanguageChanged={this.onLanguageChanged}
 *     />
 *   );
 * }
 */

type Props = {
  language?: string;
  initialText: string;
  onLanguageChanged?: (a: string) => void;
  bodyAttributes?: BodyAttribute[];
};

type State = {
  text: string;
};

class TranslatableText extends React.Component<Props, State> {
  // @ts-expect-error ts-migrate(2564) FIXME: Property 'props' has no initializer and is not def... Remove this comment to see the full error message
  props: Props;
  state: State;

  static defaultProps = {
    language: null,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      text: props.initialText,
    };
    this.addToCache(props.language, props.initialText);
  }

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'nextProps' implicitly has an 'any' type... Remove this comment to see the full error message
  componentWillReceiveProps(nextProps) {
    if (this.props.language !== nextProps.language) {
      this.translateTo(nextProps.language);
    }
    if (this.props.initialText !== nextProps.initialText) {
      this.setState({ text: nextProps.initialText });
    }
  }

  cache: {
    [language: string]: string;
  } = {};

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'locale' implicitly has an 'any' type.
  addToCache = (locale, text) => {
    this.cache[locale] = text;
  };

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'locale' implicitly has an 'any' type.
  translateTo = (locale) => {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
    const onTranslationSuccess = (response) => {
      this.setState({ text: response.translation });

      if (this.props.onLanguageChanged) {
        this.props.onLanguageChanged(locale);
      }

      return response;
    };

    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
    const addToCache = (response) => {
      this.addToCache(locale, response.translation);
    };

    if (this.cache[locale]) {
      this.setState({ text: this.cache[locale] });

      if (this.props.onLanguageChanged) {
        this.props.onLanguageChanged(locale);
      }
    } else {
      TranslationActions.translate(this.props.initialText, locale)
        .then(onTranslationSuccess)
        .then(addToCache)
        .catch(errorLogger('TranslationActions.translate failed'));
    }
  };

  render() {
    const entities = [].concat(
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      TextEntities.parseEmoji(this.state.text),
      TextEntities.parseNewlines(this.state.text),
      TextEntities.parseLeadingWhitespace(this.state.text),
      TextEntities.parseUrls(this.state.text, this.props.bodyAttributes)
    );

    return (
      <div className="TranslatableText">
        <TextWithEntities text={this.state.text} entities={entities} />
      </div>
    );
  }
}

export default TranslatableText;
